import { useAuth } from "react-oidc-context";
import logo from "../../assets/albertine-icon.svg";
import Button from "../Common/Buttons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import "./Login.css";

type Props = {
    mode: "auto" | "manual" | "error";
    returnTo: string;
};

const Login = function Login(props: Props) {
    const { mode, returnTo } = props;
    const auth = useAuth();

    const handleClick = () => {
        void auth.signinRedirect({ state: { returnTo } });
    };

    return (
        <div className="login">
            <div className="login-inner">
                <img src={logo} className="logo" alt="Albertine" />
                {mode === "auto" ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        {mode === "error" && (
                            <div className="mb-4 text-center text-destructive text-sm">
                                Something went wrong. Please try again.
                            </div>
                        )}
                        <Button
                            onClick={handleClick}
                            showLoadingSpinner={auth.isLoading}
                        >
                            Login
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default Login;
